import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';

class SubmitTimeslotSuccess extends Component {

    closeWindow = () => {
        window.close();
    }

    render(){
        return (
            <div className='content success'>
                <div className='general-width margin-width-auto absolute-center'>
                    <div className='image-container'>
                        <span className="icon icon-calendar-accepted apply-with-icon desktop">
                            <span className="path1"></span>
                            <span className="path2"></span>
                            <span className="path3"></span>
                            <span className="path4"></span>
                            <span className="path5"></span>
                            <span className="path6"></span>
                            <span className="path7"></span>
                            <span className="path8"></span>
                            <span className="path9"></span>
                            <span className="path10"></span>
                            <span className="path11"></span>
                            <span className="path12"></span>
                            <span className="path13"></span>
                            <span className="path14"></span>
                        </span>
                        <h2 className='header-text'>{window['i18n']['JOBSEEKER_TIME_SLOT_SUBMIT_SUCCESS_TITLE']}</h2> 
                    </div>
                    <div className='message-container'>
                    <label className="x-large dark-tri">
                        <h2 className='title-text'>{window['i18n']['JOBSEEKER_TIME_SLOT_SUBMIT_SUCCESS_TITLE']}</h2>
                        <p className='desc-text'>{window['i18n']['JOBSEEKER_TIME_SLOT_SUBMIT_SUCCESS']}</p>
                    </label>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(SubmitTimeslotSuccess)